import { Box, List, ListItem, Typography } from '@mui/material'
import React from 'react'
import theme from 'theme'

interface Props {
  content: any
  data: any
}

const ReportElementLegend: React.FC<Props> = ({ content, data }) => {
  const legend = content.use_default_values ? data.legend : content.legend
  const legendItems = legend ? content.legend_items : undefined

  if (legendItems && Object.keys(legendItems).length > 0) {
    return (
      <Box px={4} pt={2}>
        <List sx={{ display: 'flex', padding: '0px' }}>
          {Object.keys(legendItems)
            .sort()
            .map((key) => (
              <ListItem
                key={key}
                sx={{
                  width: 'auto',
                  paddingLeft: '0px',
                  paddingRight: theme.spacing(4),
                }}
              >
                <Typography component="span" sx={{ fontWeight: 'bold' }}>
                  {key}
                </Typography>
                <Typography component="span" px={0.5}>
                  =
                </Typography>
                <Typography component="span">{legendItems[key]}</Typography>
              </ListItem>
            ))}
        </List>
      </Box>
    )
  }
  if (legend) {
    return (
      <Box px={4} pt={2}>
        <Typography>{legend}</Typography>
      </Box>
    )
  }
  return null
}

export default ReportElementLegend
